/* w9-product-details (2026-09-23)
   Reads the product description rendered by sections/w9-product-details.liquid and lifts out:
     - fitment rows ("125 EXC: 1998–2005", "HONDA CRF 450 R 2009-2014", "Talaria MX3 / MX4") into a
       searchable, make-filtered list that also checks the bike remembered by the bike finder (localStorage w9_bike);
     - "KEY: value" spec lines into a spec grid; exclusion sentences into a warning; red rows into a tag.
   Lifted lines are removed from the prose so nothing shows twice; unrecognised text stays put.
   With no fitment list, the description's video/tables/pictures take the right-hand column instead.
   A custom.fitment_json metafield ({verified, rows:[{make,model,years}]}) overrides the parsed rows.
   2026-10-24: the section also passes the bikes the store lists this part for (data-w9pd-bikes: bike menu
   models whose collection or tag the product has, as w9-goes-with and w9-fit-check read them). A description
   list without a single year is usually prose the parser caught, so then the store's list is shown and those
   lines go back to the prose. The rider's bike counts as listed when the store lists it or the description
   does; a universal part (All Make / universal-fit) fits any bike. */
(function () {
  Array.prototype.forEach.call(document.querySelectorAll('.w9pd[data-w9pd]'), function (root) { try { run(root); } catch (e) { if (window.console) console.warn('w9pd', e); } });

  function run(root) {
  var src = root.querySelector('[data-w9pd-source]');
  if (!src) return;

  /* ---------- patterns ---------- */
  var Y = '(?:19|20)\\d{2}';
  var OPEN = '(?:current|present|now|up|on|onwards|newer|\\+)';
  var YR = Y + '(?:\\s*(?:-|–|—|to|thru|through|/)\\s*(?:' + Y + '|' + OPEN + '))?';
  var YEARS = '(?:' + YR + '(?:\\s*(?:,|&|and|\\+|;)\\s*' + YR + ')*|current|present)';
  var ROW = new RegExp('^(.{1,80}?)[\\s:–\\-]*\\b(' + YEARS + ')\\s*\\.?$', 'i');
  var YEARONLY = new RegExp('^' + YEARS + '$', 'i');
  var LEAD = new RegExp('^(' + YEARS + ')[\\s:–\\-]+(\\S.*)$', 'i');
  var MARK = /^(?:fitments?(?:\s+(?:below|list|guide|info(?:rmation)?|chart|bikes?|models?))?|fits?(?:\s+(?:these|the\s+following|the))?(?:\s+(?:models?|bikes?|machines?|vehicles?))?|fitment\s+bikes?|applications?|compatib(?:le|ility)(?:\s+(?:with|bikes?|models?))?|will\s+fit|models?\s+(?:supported|list)|supported\s+models?|vehicle\s+fitment|(?:year\s*\/\s*)?make\s*\/\s*model)\b\s*[:\-–]?\s*(.*)$/i;
  var EXCL = /^(?:\*+\s*)?(?:does\s+not|do\s+not|doesn['’]t|will\s+not|won['’]t|not\s+(?:for|compatible)|excludes?|except|no\s+fit|not\s+fit)/i;
  var SPEC = /^([A-Za-z][A-Za-z0-9 /().\-]{1,28}?)\s*:\s*(.{1,80})$/;
  var MODEL_HINT = /\d|\b(?:light\s*bee|ultra\s*bee|lbx|lbs|sting|komodo|mantis|varg|falcon|bee)\b/i;
  var MAKES = [['ktm','KTM'],['husqvarna','Husqvarna'],['husky','Husqvarna'],['husaberg','Husaberg'],['gasgas','GasGas'],['gas gas','GasGas'],['gas-gas','GasGas'],['honda','Honda'],['yamaha','Yamaha'],['suzuki','Suzuki'],['kawasaki','Kawasaki'],['kawi','Kawasaki'],['beta','Beta'],['sherco','Sherco'],['fantic','Fantic'],['rieju','Rieju'],['stark varg','Stark'],['stark','Stark'],['polaris','Polaris'],['can-am','Can-Am'],['can am','Can-Am'],['canam','Can-Am'],['arctic cat','Arctic Cat'],['kymco','Kymco'],['sur-ron','Sur-Ron'],['surron','Sur-Ron'],['sur ron','Sur-Ron'],['talaria','Talaria'],['segway','Segway'],['e-ride pro','E-Ride Pro'],['e ride pro','E-Ride Pro'],['eride pro','E-Ride Pro'],['e-ride','E-Ride Pro'],['eride','E-Ride Pro'],['rawrr','Rawrr'],['79bike','79Bike'],['79 bike','79Bike'],['ventus','Ventus'],['rfn','RFN'],['apollo','Apollo'],['rerode','Rerode'],['bonnell','Bonnell'],['ducati','Ducati'],['triumph','Triumph'],['kove','Kove'],['zero','Zero'],['cake','Cake'],['altis','Altis'],['harley-davidson','Harley-Davidson'],['harley','Harley-Davidson'],['bmw','BMW'],['aprilia','Aprilia'],['christini','Christini'],['ajp','AJP'],['ossa','Ossa'],['montesa','Montesa'],['electric motion','Electric Motion'],['alta','Alta'],['tm racing','TM'],['tm','TM']];
  MAKES.sort(function (a, b) { return b[0].length - a[0].length; });
  function esc(s) { return s.replace(/[.*+?^$()|[\]\\{}]/g, '\\$&'); }
  var MAKE_RE = new RegExp('^(' + MAKES.map(function (m) { return esc(m[0]); }).join('|') + ')\\b[\\s:\\-–]*', 'i');
  function canonMake(s) { s = s.toLowerCase().replace(/[:\-–]\s*$/, '').trim(); for (var i = 0; i < MAKES.length; i++) if (MAKES[i][0] === s) return MAKES[i][1]; return null; }
  function makeAt(line) { var m = line.match(MAKE_RE); return m ? { make: canonMake(m[1]), rest: line.slice(m[0].length) } : null; }
  function isRed(el) { try { var c = getComputedStyle(el).color.match(/\d+/g); return !!c && +c[0] > 170 && +c[1] < 110 && +c[2] < 110; } catch (e) { return false; } }
  var THIS_YEAR = new Date().getFullYear();

  /* ---------- 1. split the description into visual lines, remembering their nodes ---------- */
  var BLOCK = /^(P|DIV|LI|H[1-6]|TR|TD|TH|BLOCKQUOTE|PRE|SECTION|ARTICLE|UL|OL|TABLE|TBODY|THEAD|DL|DT|DD)$/;
  var SKIP = /^(IMG|IFRAME|VIDEO|TABLE|SCRIPT|STYLE|META|LINK)$/;
  /* pasted-in descriptions often carry a stray A-circumflex (a mis-decoded non-breaking space) */
  (function scrub(node) {
    for (var n = node.firstChild; n; n = n.nextSibling) {
      if (n.nodeType === 3) { if (n.nodeValue.indexOf('\u00c2') >= 0) n.nodeValue = n.nodeValue.replace(/\u00c2(?=[\s\u00a0]|$)/g, ''); }
      else if (n.nodeType === 1 && !SKIP.test(n.tagName)) scrub(n);
    }
  })(src);
  var segs = [];
  function walk(block) {
    var cur = null;
    function flush(br) { if (cur && cur.text.replace(/\u00a0/g, ' ').trim()) { cur.br = br || null; segs.push(cur); } cur = null; }
    (function rec(node) {
      for (var n = node.firstChild; n; n = n.nextSibling) {
        if (n.nodeType === 3) {
          if (!cur) { if (!n.nodeValue.trim()) continue; cur = { text: '', nodes: [], red: false, block: block, lines: [] }; }
          cur.text += n.nodeValue; cur.nodes.push(n);
          if (n.nodeValue.trim() && n.parentElement && isRed(n.parentElement)) cur.red = true;
        } else if (n.nodeType === 1) {
          if (n.tagName === 'BR') flush(n);
          else if (SKIP.test(n.tagName)) flush(null);
          else if (BLOCK.test(n.tagName)) { flush(null); walk(n); }
          else rec(n);
        }
      }
    })(block);
    flush(null);
  }
  walk(src);

  var lines = [];
  segs.forEach(function (seg) {
    seg.text.split(/\s*[•·▪●]\s*/).forEach(function (p) {
      p = p.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
      if (!p) return;
      var L = { text: p, seg: seg, used: false };
      seg.lines.push(L); lines.push(L);
    });
  });

  /* ---------- 2. classify ---------- */
  var rows = [], specs = [], warns = [], legend = '';
  var mode = false, curMake = '', marker = null, fitLines = [];
  function consume(L) { if (L) L.used = true; }
  function release(L) { if (L && !L.virtual) L.used = false; }
  /* lines taken for the fitment list, so they can go back to the prose if the list is dropped */
  function fitConsume(L) { consume(L); fitLines.push(L); }
  function normYears(s) {
    return s.replace(/\s*(?:-|–|—|to|thru|through|\/)\s*/gi, ' – ')
      .replace(/current|present|now|onwards|newer|up|on|\+/gi, 'current')
      .replace(/\s*[,;&]\s*|\s+and\s+/gi, ', ').replace(/\s*\+\s*$/, '').trim();
  }
  function yearList(s) {
    var out = [], re = new RegExp(YR, 'gi'), m;
    while ((m = re.exec(s))) {
      var parts = m[0].split(/\s*(?:-|–|—|to|thru|through|\/)\s*/i);
      var a = +parts[0], b = parts[1] ? (/\d{4}/.test(parts[1]) ? +parts[1] : THIS_YEAR + 1) : a;
      if (b < a) { var t = a; a = b; b = t; }
      for (var y = a; y <= b && y - a < 60; y++) out.push(String(y));
    }
    if (/current|present/i.test(s) && !out.length) out.push(String(THIS_YEAR), String(THIS_YEAR + 1));
    return out;
  }
  function listAhead(i) { var n = 0; for (var k = i; k < Math.min(lines.length, i + 4); k++) if (ROW.test(lines[k].text)) n++; return n >= 3; }
  function pushRow(makeHit, modelText, years, red) {
    var model = modelText.replace(/[\s:\-–]+$/, '').replace(/^[\s:\-–]+/, '').trim();
    /* years written first ("1995-2007 Honda CR125") */
    var lead = !years && model.match(LEAD);
    if (lead) { years = lead[1]; model = lead[2].trim(); if (!makeHit) { makeHit = makeAt(model); if (makeHit) model = makeHit.rest.trim(); } }
    var make = makeHit ? makeHit.make : (curMake || (rows.length ? rows[rows.length - 1].make : ''));
    if (!model && makeHit) { model = 'All models'; make = makeHit.make; }
    if (!model) return false;
    rows.push({ make: make || '', model: model, years: years ? normYears(years) : '', ylist: years ? yearList(years) : [], red: !!red });
    return true;
  }

  for (var i = 0; i < lines.length; i++) {
    var L = lines[i], t = L.text;
    var cm = canonMake(t);
    if (cm && (mode || listAhead(i + 1))) {
      /* a bare make name is a group header when plain rows follow ("KTM" then "125 EXC: 1998-2005"),
         otherwise it is an entry of its own ("RFN", "Apollo" in an e-moto list) */
      var nxt = lines[i + 1];
      var headerLike = nxt && !makeAt(nxt.text) && (ROW.test(nxt.text) || (mode && nxt.text.length <= 48 && MODEL_HINT.test(nxt.text)));
      mode = true; fitConsume(L);
      if (headerLike) curMake = cm; else rows.push({ make: cm, model: 'All models', years: '', ylist: [], red: L.seg.red });
      continue;
    }

    var mk = t.match(MARK);
    if (mk && !ROW.test(t)) {
      var rest = (mk[1] || '').trim();
      if (rest.length <= 90) {
        if (mode && rows.length === 0 && marker) release(marker);
        mode = true; marker = L; curMake = ''; fitConsume(L);
        var par = rest.match(/\(([^)]{3,90})\)/);
        if (par) { legend = par[1]; rest = rest.replace(/\([^)]*\)/, '').trim(); }
        if (rest) {
          if (EXCL.test(rest)) warns.push(rest);
          else lines.splice(i + 1, 0, { text: rest, seg: L.seg, used: true, virtual: true });
        }
        continue;
      }
    }

    if (mode) {
      if (EXCL.test(t) && t.length < 160) { warns.push(t); consume(L); continue; }
      var rm = t.match(ROW);
      if (rm && rm[1].trim()) { var mh = makeAt(rm[1].trim()); if (pushRow(mh, mh ? mh.rest : rm[1], rm[2], L.seg.red)) { fitConsume(L); continue; } }
      var ma = makeAt(t);
      if (t.length <= 48 && !/[.!?]$/.test(t) && t.split(' ').length <= 8 && (ma || MODEL_HINT.test(t)) && pushRow(ma, ma ? ma.rest : t, '', L.seg.red)) { fitConsume(L); continue; }
      if (rows.length === 0 && marker) release(marker);
      mode = false; curMake = ''; marker = null;
    }

    if (!mode) {
      if (ROW.test(t) && listAhead(i)) { mode = true; i--; continue; }
      var sp = t.match(SPEC);
      if (sp && !mk && sp[1].trim().split(' ').length <= 4 && !YEARONLY.test(sp[2]) && !/https?:|@/.test(t) && !canonMake(sp[1]) && !/^(?:notes?|tips?|warning|important|please note|nb|ps|update|see|click|link|shipping|price|sale|pre-?sale|attention|caution)$/i.test(sp[1].trim())) {
        specs.push({ k: sp[1].trim(), v: sp[2].trim(), line: L }); consume(L); continue;
      }
    }
  }
  if (mode && rows.length === 0 && marker) release(marker);
  if (specs.length < 2) { specs.forEach(function (s) { release(s.line); }); specs = []; }

  /* ---------- 3. structured override (Crew Chief seam) ---------- */
  var verified = false, jsonEl = root.querySelector('[data-w9pd-json]');
  if (jsonEl) {
    try {
      var ext = JSON.parse(jsonEl.textContent);
      if (ext && ext.rows && ext.rows.length) {
        rows = ext.rows.map(function (r) { var ys = String(r.years || ''); return { make: r.make || '', model: r.model || '', years: ys ? normYears(ys) : '', ylist: yearList(ys), red: false }; });
        verified = !!ext.verified;
      }
    } catch (e) {}
  }

  /* ---------- 3b. the bikes the store lists this part for (bike pages: collections and tags) ---------- */
  var bikes = [], universal = false, partTag = '', partTitle = '', bikesEl = root.querySelector('[data-w9pd-bikes]');
  if (bikesEl) { try { var bj = JSON.parse(bikesEl.textContent); bikes = bj.bikes || []; universal = !!bj.universal; partTag = bj.part || ''; partTitle = bj.partTitle || ''; } catch (e) {} }
  /* a description list without a single year is usually prose the parser caught ("Light weight 7075T6 forged
     aluminum"): show the store's list instead and give those lines back to the prose */
  if (!verified && bikes.length && !rows.some(function (r) { return r.years; })) {
    fitLines.forEach(release);
    rows = bikes.map(function (b) { return { make: b.make, model: b.model, years: '', ylist: [], red: false, h: b.h }; });
  }
  /* the bike remembered by the bike finder, and whether the store lists this part for it */
  var saved = null; try { saved = JSON.parse(localStorage.getItem('w9_bike') || 'null'); } catch (e) {}
  function slug(s) { return String(s || '').toLowerCase().replace(/['"]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  /* b inside a without splitting a run of digits or letters: CR125 is in CR125R, but 50 SX is not in 450 SX-F
     and 450 SX is not in 450 SX-F */
  function within(a, b) {
    var i = a.indexOf(b); if (i < 0) return false;
    var before = a.charAt(i - 1), after = a.charAt(i + b.length);
    if (before && /\d/.test(before) === /\d/.test(b.charAt(0))) return false;
    if (after && /\d/.test(after) === /\d/.test(b.charAt(b.length - 1))) return false;
    return true;
  }
  function rowHits() {
    var sm = norm(saved && saved.model), smk = norm(saved && saved.make);
    return sm ? rows.filter(function (r) {
      var rm = norm(r.model), rmk = norm(r.make);
      var makeOk = !rmk || !smk || rmk === smk || rmk.indexOf(smk) >= 0 || smk.indexOf(rmk) >= 0;
      return makeOk && (rm === sm || (rm.length >= 3 && within(sm, rm)) || (sm.length >= 3 && within(rm, sm)));
    }) : [];
  }
  var storeHit = null;
  if (saved && bikes.length && !universal) {
    var sh = (String(saved.url || '').split('/collections/')[1] || '').split(/[?#\/]/)[0].toLowerCase();
    var smm = slug((saved.make || '') + ' ' + (saved.model || ''));
    storeHit = bikes.filter(function (b) { return (sh && (b.h === sh || b.mm === sh)) || (smm && b.mm === smm); })[0] || null;
    /* listed by the store but missing from the description's list: show it, so the answer points at a row */
    if (storeHit && !rowHits().length && !rows.some(function (r) { return r.h && r.h === storeHit.h; }))
      rows.unshift({ make: storeHit.make, model: storeHit.model, years: '', ylist: [], red: false, h: storeHit.h });
  }

  /* ---------- 4. take the lifted lines out of the prose ---------- */
  segs.forEach(function (seg) {
    if (!seg.lines.length) return;
    var used = seg.lines.filter(function (l) { return l.used; }).length;
    if (!used) return;
    if (used === seg.lines.length) {
      seg.nodes.forEach(function (n) { if (n.parentNode) n.parentNode.removeChild(n); });
      if (seg.br && seg.br.parentNode) seg.br.parentNode.removeChild(seg.br);
    } else {
      var keep = seg.lines.filter(function (l) { return !l.used; }).map(function (l) { return l.text; }).join(' · ');
      seg.nodes.forEach(function (n, idx) { n.nodeValue = idx === 0 ? keep : ''; });
    }
  });
  function tidy() {
    var all = Array.prototype.slice.call(src.querySelectorAll('*')).reverse();
    all.forEach(function (el) {
      if (SKIP.test(el.tagName) || /^(BR|HR|TD|TH|TR|TBODY|THEAD|COL|COLGROUP|INPUT|BUTTON|SELECT|SVG|PATH)$/.test(el.tagName)) return;
      if (el.querySelector('img,iframe,video,table,svg')) return;
      if (!el.textContent.replace(/\u00a0/g, ' ').trim()) el.parentNode && el.parentNode.removeChild(el);
    });
    /* a heading whose content was lifted out ("Specs" above a KEY: value list) is left pointing at nothing: drop it */
    Array.prototype.forEach.call(src.querySelectorAll('h2,h3,h4,h5,h6'), function (h) {
      var n = h.nextSibling;
      while (n && n.nodeType === 3 && !n.nodeValue.trim()) n = n.nextSibling;
      if (!n || (n.nodeType === 1 && /^H[1-6]$/.test(n.tagName))) h.parentNode && h.parentNode.removeChild(h);
    });
    Array.prototype.forEach.call(src.querySelectorAll('p,div,li,h1,h2,h3,h4,h5,h6'), function (b) {
      var f; while ((f = b.firstChild) && ((f.nodeType === 3 && !f.nodeValue.trim()) || f.tagName === 'BR')) b.removeChild(f);
      var l; while ((l = b.lastChild) && ((l.nodeType === 3 && !l.nodeValue.trim()) || l.tagName === 'BR')) b.removeChild(l);
    });
  }
  tidy();
  /* pasted descriptions sometimes carry white text (inline #FFFFFF, <font>, theme th rules):
     anything that resolves to near-white on a light background is forced back to ink */
  function lum(c) { var m = String(c || '').match(/\d+(?:\.\d+)?/g); if (!m || m.length < 3) return null; if (m.length > 3 && +m[3] === 0) return null; return (0.2126 * m[0] + 0.7152 * m[1] + 0.0722 * m[2]) / 255; }
  function bgLum(el) { while (el && el !== document.body) { var l = lum(getComputedStyle(el).backgroundColor); if (l !== null) return l; el = el.parentElement; } return 1; }
  function inkify() {
    Array.prototype.forEach.call(root.querySelectorAll('.w9pd__prose *, .w9pd__side *'), function (el) {
      if (!el.textContent.trim() || /^(SCRIPT|STYLE|IFRAME|VIDEO|IMG|SVG)$/.test(el.tagName)) return;
      var l = lum(getComputedStyle(el).color);
      if (l !== null && l > 0.85 && bgLum(el) > 0.6) el.classList.add('w9pd-ink');
    });
  }

  /* ---------- 5. render specs ---------- */
  if (specs.length) {
    var dl = root.querySelector('[data-w9pd-specs]');
    specs.forEach(function (s) {
      var d = document.createElement('div'); d.className = 'w9pd__spec';
      var dt = document.createElement('dt'); dt.textContent = s.k.charAt(0).toUpperCase() + s.k.slice(1).toLowerCase();
      var dd = document.createElement('dd'); dd.textContent = s.v;
      d.appendChild(dt); d.appendChild(dd); dl.appendChild(d);
    });
    dl.hidden = false;
  }

  /* ---------- 6. render fitment ---------- */
  var fit = root.querySelector('[data-w9pd-fit]');
  var minWide = +root.getAttribute('data-min-wide') || 12;
  if (!rows.length) {
    /* no fitment list: give the right column to the description's video, tables and pictures */
    var side = root.querySelector('[data-w9pd-side]');
    Array.prototype.forEach.call(src.querySelectorAll('iframe, video, table, img'), function (m) {
      if (!m.parentNode || side.contains(m)) return;
      var host = m;
      while (host.parentNode && host.parentNode !== src && host.parentNode.textContent.replace(/\s+/g, '').length <= m.textContent.replace(/\s+/g, '').length + 40) host = host.parentNode;
      if (m.tagName === 'TABLE') {
        var card = document.createElement('div'); card.className = 'w9pd__sidecard';
        /* a short heading sitting directly above the table ("Size chart", "What is in the range") is its title: take it along */
        var cap = host.previousElementSibling;
        while (cap && cap.nodeType === 1 && !cap.textContent.trim()) cap = cap.previousElementSibling;
        if (cap && /^H[2-6]$/.test(cap.tagName) && cap.textContent.trim().length <= 48) { cap.classList.add('w9pd__sidecard-title'); card.appendChild(cap); }
        card.appendChild(host === m ? m : host); side.appendChild(card);
      }
      else side.appendChild(host);
    });
    tidy();
    if (side.children.length) { side.hidden = false; root.setAttribute('data-fit', 'media'); }
    else root.setAttribute('data-fit', 'none');
    if (!src.textContent.trim() && !specs.length && !side.children.length) root.hidden = true;
    inkify();
    return;
  }
  root.setAttribute('data-fit', rows.length >= minWide ? 'wide' : 'narrow');
  fit.hidden = false;
  if (verified) root.querySelector('[data-w9pd-verified]').hidden = false;
  if (!src.textContent.trim() && !specs.length) root.querySelector('.w9pd__about').style.display = 'none';

  var groups = [], byMake = {};
  rows.forEach(function (r) { var k = r.make || ''; if (!byMake[k]) { byMake[k] = { make: k, rows: [] }; groups.push(byMake[k]); } byMake[k].rows.push(r); });
  var namedMakes = groups.filter(function (g) { return g.make; }).length;
  var onlyMake = namedMakes === 1 && groups.length === 1 ? groups[0].make + ' ' : '';
  root.querySelector('[data-w9pd-count]').textContent = rows.length + ' ' + onlyMake + (rows.length === 1 ? 'model' : 'models') + (namedMakes > 1 ? ' · ' + namedMakes + ' makes' : '');

  var warnBox = root.querySelector('[data-w9pd-warns]');
  warns.forEach(function (w) {
    var d = document.createElement('div'); d.className = 'w9pd__warn';
    d.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 9v4m0 4h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"/></svg>';
    var s = document.createElement('span'); s.textContent = w.charAt(0).toUpperCase() + w.slice(1); d.appendChild(s); warnBox.appendChild(d);
  });

  var anyRed = rows.some(function (r) { return r.red; });
  var legendEl = root.querySelector('[data-w9pd-legend]');
  if (anyRed) { legendEl.textContent = 'Tagged models: ' + (legend ? legend.replace(/^highlighted\s+red\s*[-–:]?\s*/i, '').toLowerCase() : 'fits the Warp 9 hub only'); legendEl.hidden = false; }
  if (universal && !anyRed) { legendEl.textContent = 'Universal part: Warp 9 lists it for any bike.'; legendEl.hidden = false; }
  var tagText = legend && /warp\s*9/i.test(legend) ? 'W9 hub' : 'See note';

  var list = root.querySelector('[data-w9pd-list]');
  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ''); }
  groups.forEach(function (g) {
    var gid = norm(g.make) || 'other';
    if (groups.length > 1) { var h = document.createElement('li'); h.className = 'w9pd__make'; h.setAttribute('data-make', gid); h.textContent = g.make || 'Other'; list.appendChild(h); }
    g.rows.forEach(function (r) {
      var li = document.createElement('li'); li.className = 'w9pd__row'; li.setAttribute('data-make', gid);
      li.setAttribute('data-q', [g.make, r.model, norm(r.model), r.years, r.ylist.join(' ')].join(' ').toLowerCase());
      var m = document.createElement('span'); m.className = 'w9pd__model'; m.textContent = r.model;
      if (r.red) { var tg = document.createElement('span'); tg.className = 'w9pd__tag'; tg.textContent = tagText; m.appendChild(tg); }
      var y = document.createElement('span'); y.className = 'w9pd__years'; y.textContent = r.years;
      li.appendChild(m); li.appendChild(y); list.appendChild(li); r.el = li;
    });
  });

  /* chips */
  var makesEl = root.querySelector('[data-w9pd-makes]'), activeMake = 'all';
  function chip(id, label, n) { var b = document.createElement('button'); b.type = 'button'; b.className = 'w9pd__chip'; b.setAttribute('data-make', id); b.textContent = label; var s = document.createElement('small'); s.textContent = n; b.appendChild(s); makesEl.appendChild(b); return b; }
  if (groups.length > 1) {
    chip('all', 'All', rows.length);
    groups.slice().sort(function (a, b) { return b.rows.length - a.rows.length; }).forEach(function (g) { chip(norm(g.make) || 'other', g.make || 'Other', g.rows.length); });
    makesEl.addEventListener('click', function (e) { var b = e.target.closest('.w9pd__chip'); if (!b) return; activeMake = b.getAttribute('data-make'); apply(); });
  } else { makesEl.hidden = true; }

  var search = root.querySelector('[data-w9pd-search]'), emptyEl = root.querySelector('[data-w9pd-empty]');
  function apply() {
    var q = norm(search.value), toks = search.value.toLowerCase().split(/\s+/).filter(Boolean), shown = 0;
    Array.prototype.forEach.call(makesEl.children, function (b) { b.classList.toggle('is-on', b.getAttribute('data-make') === activeMake); });
    var visibleMakes = {};
    rows.forEach(function (r) {
      var li = r.el, ok = activeMake === 'all' || li.getAttribute('data-make') === activeMake;
      if (ok && toks.length) { var hay = li.getAttribute('data-q'); ok = toks.every(function (t) { return hay.indexOf(t) >= 0 || hay.indexOf(norm(t)) >= 0; }) || (q && hay.indexOf(q) >= 0); }
      li.classList.toggle('is-hidden', !ok);
      if (ok) { shown++; visibleMakes[li.getAttribute('data-make')] = 1; }
    });
    Array.prototype.forEach.call(list.querySelectorAll('.w9pd__make'), function (h) { h.classList.toggle('is-hidden', !visibleMakes[h.getAttribute('data-make')]); });
    emptyEl.hidden = shown > 0;
  }
  search.addEventListener('input', apply);

  /* the rider's bike: listed when the description lists it or the store does */
  var my = root.querySelector('[data-w9pd-mybike]');
  var contact = root.getAttribute('data-contact') || '';
  if (saved && (saved.model || saved.label)) {
    var smk = norm(saved.make || '');
    /* the store's own row when it lists the bike, else the description's rows that name it */
    var hits = storeHit ? rows.filter(function (r) { return r.h === storeHit.h; }) : [];
    if (!hits.length) hits = rowHits();
    var label = saved.label || ((saved.make || '') + ' ' + (saved.model || '')).trim();
    my.hidden = false;
    if (hits.length) {
      my.className = 'w9pd__mybike is-hit';
      var yrs = hits.map(function (r) { return r.years; }).filter(Boolean).filter(function (v, i, a) { return a.indexOf(v) === i; }).join(', ');
      my.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
      var s1 = document.createElement('span'); s1.innerHTML = '<strong></strong> is listed' + (yrs ? ': ' : '') ; s1.querySelector('strong').textContent = 'Your ' + label; if (yrs) { var yy = document.createElement('span'); yy.textContent = yrs; s1.appendChild(yy); } my.appendChild(s1);
      hits.forEach(function (r) { r.el.classList.add('is-mine'); });
      var hitMake = norm(hits[0].make); if (hitMake && byMake[hits[0].make] && groups.length > 1) activeMake = hitMake;
    } else if (universal) {
      my.className = 'w9pd__mybike is-hit';
      my.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
      var su = document.createElement('span'); var stu = document.createElement('strong'); stu.textContent = 'Your ' + label; su.appendChild(stu); su.appendChild(document.createTextNode(': this part fits any bike.')); my.appendChild(su);
    } else {
      my.className = 'w9pd__mybike is-miss';
      my.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><circle cx="12" cy="12" r="9"/><path d="M12 8v4m0 4h.01"/></svg>';
      var s2 = document.createElement('span'); var st = document.createElement('strong'); st.textContent = 'Your ' + label; s2.appendChild(st); s2.appendChild(document.createTextNode(' is not in this list.'));
      if (contact) { var a = document.createElement('a'); a.href = contact; a.textContent = ' Ask us first'; s2.appendChild(a); }
      /* the bike's own page filtered to this part, as the fit check offers */
      if (partTag && saved.url && String(saved.url).indexOf('/collections/') >= 0) {
        var see = document.createElement('a'); see.href = String(saved.url).split('?')[0].replace(/\/+$/, '') + '/' + partTag;
        see.textContent = 'See the ' + (partTitle || 'parts') + ' for your ' + label;
        s2.appendChild(document.createElement('br')); s2.appendChild(see);
      }
      my.appendChild(s2);
      if (smk && byMake[saved.make]) activeMake = smk;
    }
  }
  apply();
  inkify();
  }
})();